<template>
	<div id="app">
		<router-view> </router-view>
		
	</div>
</template>

<script>
	import login from "./views/Login.vue"
	export default {
		name: "App",
		components: {
			login,
		},
		created() {},
	};
</script>

<style>
	/* @import url("assets/css/style.css") */
</style>
